import React from "react";
import connect from "react-redux/es/connect/connect";
import importedStyles from './DetailVideoModalIframe.module.sass';
import CloseIcon from '@material-ui/icons/CloseRounded';
import Vimeo from '@u-wave/react-vimeo';
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import {Divider, Fab, Fade, Hidden, withStyles} from "@material-ui/core";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowLeftIcon from "@material-ui/icons/ChevronLeftRounded";
import ArrowRightIcon from "@material-ui/icons/ChevronRightRounded";
import PropTypes from "prop-types";
import LinearProgress from "@material-ui/core/LinearProgress";
import Snack from "../../../../components/Snack/Snack";
import Grid from "@material-ui/core/Grid";
import chicaError from "../../../../animations/chica-error.json";
import Lottie from "react-lottie";
import {sendStat} from "../../../../helpers/stats/statsAPI";
import {ReactComponent as NavigationArrow} from "../../../../icons/navigationArrow.svg";
import {secondaryColor} from "../../../../styles/palette";
import DialogContent from "@material-ui/core/DialogContent";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button/Button";
import ArrowBackIcon from "../../../../icons/arrow_back_iframe.svg";
import ArrowForwardIcon from '../../../../icons/arrow_forward_iframe.svg';
import {mediumFontSize} from "../../../../styles/typography";
import {smallFontSize} from "../../../../styles/typography";
import {LanguageSelector} from "../../../../components/LanguageSelector/LanguageSelector";
import {ChevronLeftSharp, ChevronRightSharp} from "@material-ui/icons";
import WhatsappButton from "../../../../components/WhastappButton/WhatsappButton";
import {getTranslatedText} from "../../../../helpers/language";
import Interweave, {ALLOWED_TAG_LIST} from "interweave";


const isMobile = window.matchMedia("(max-width: 768px)").matches;

const useStyles = theme => ({
    dialog: {
        [theme.breakpoints.up('md')]: {
            borderRadius: (props) => (props.borderRadius === null || props.borderRadius === undefined) ? 48 : props.borderRadius,
            overflowY: 'visible'
        },
    },
    iframeStyle: {
        width: '100%',
        transition: 'opacity 0.25s, height 0.25s',
        '& iframe': {
            width: '100%',
            // borderRadius: (props) => (props.borderRadius === null || props.borderRadius === undefined) ? 20 : props.borderRadius,
            [theme.breakpoints.down('md')]: {
                height: 350
            },
            [theme.breakpoints.up('md')]: {
                height: 420
            },
        }
    },
    mainImage: {
        maxHeight: '50vh',
        maxWidth: '100%',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            width: '100%',
            borderRadius: (props) => (props.borderRadius === null || props.borderRadius === undefined) ? 20 : props.borderRadius,
        },
    },
    cta: {
        color: '#fff',
        backgroundColor: '#000000',
        textTransform: 'none',
        padding: '5px 25px',
        // marginTop: ' 0.5rem',
        // marginBottom: '0.5rem',
        fontSize: mediumFontSize,
        zIndex: 1290,
        transition: '0.5s',
        fontWeight: 400,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#3d3d3e',
            color: '#fff',
        },
        [theme.breakpoints.down('sm')]: {
            borderRadius: (props) => (props.ctaBorderRadius === null || props.ctaBorderRadius === undefined) ? 8 : props.ctaBorderRadius,
            padding: '5px 20px',
            fontSize: smallFontSize,
            height: 42,
            width: '100%',
        },
        [theme.breakpoints.up('sm')]: {
            // right: '2.75rem',
            borderRadius: (props) => (props.ctaBorderRadius === null || props.ctaBorderRadius === undefined) ? 200 : props.ctaBorderRadius,
            // position: 'absolute',
            // position: 'fixed',
            // bottom: '0.7rem',
        }
    }
});

class DetailVideoModalIframe extends React.Component {


    state = {
        videoLoading: true,
        isEntered: false,
        videoError: false,
    };

    componentDidMount() {
        if (this.props.video.media_type === 'image') {
            this.setState({videoLoading: false});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.open && this.props.open) {
            // window.scrollTo({top: 0, behavior: 'smooth'});
            // let iframeParent = window.document.getElementById("grabaloVideowallIframe");
            // if (iframeParent){
            //
            //     iframeParent.scrollIntoView();
            //     const y = iframeParent.getBoundingClientRect().top + window.scrollY + -100;
            //
            //     window.scrollTo({top: -400, behavior: 'smooth'});
            // }
        }
    }

    //Pixel event
    handlePlay = () => {
        sendStat('play', null, this.props.wallUuid, this.props.video.uuid);

        let videoId = this.props.match.params.videoId;
        ReactPixel.trackCustom('VideoPlayed', {videoId: videoId});
        ReactGA.ga('send', 'event', 'video', 'VideoPlayed');
    };

    onVideoError = () => {
        // this.props.dispatch(showSnack('Error al cargar el vídeo', 'error'));
        this.setState({videoLoading: false, videoError: true});
        //this.props.onClose();
    }


    renderLeftNavigation = () => {
        return (
            <Grid item xs={1} className={importedStyles.navigationGridItemLeft}>
                {this.props.prevVideo &&
                    <IconButton id={'arrowLeft'} className={importedStyles.navigationButtonLeft}
                                onClick={this.props.handlePrevVideo}>
                        <NavigationArrow className={importedStyles.navigationIcon}/>
                    </IconButton>
                }
            </Grid>
        )
    };
    renderRightNavigation = () => {
        return (
            <Grid item xs={1} className={importedStyles.navigationGridItemRight}>
                {this.props.nextVideo &&
                    <IconButton id={'arrowRight'} className={importedStyles.navigationButtonRight}
                                onClick={this.props.handleNextVideo}>
                        <NavigationArrow className={importedStyles.navigationIcon}/>
                    </IconButton>
                }
            </Grid>
        )
    }

    renderErrorMessage = () => {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: chicaError,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return (
            <div className={importedStyles.errorMessageContainer}>
                <div className={importedStyles.animationWrapper}>
                    <Lottie options={defaultOptions}
                            height={200}
                            width={200}
                            speed={0.5}
                    />
                </div>
                <span>Parece que tenemos problemas</span>
                <span>para encontrar este vídeo</span>
            </div>

        )
    };


    renderMobileNavigation = () => {
        return (
            <React.Fragment>
                {/*{this.props.prevVideo &&*/}
                {/*    <IconButton id={'arrowLeft'} className={importedStyles.mobileNavigationButtonLeft}*/}
                {/*                onClick={this.props.handlePrevVideo}>*/}
                {/*        <NavigationArrow className={importedStyles.mobileNavigationIconLeft}/>*/}
                {/*    </IconButton>*/}
                {/*}*/}
                {this.props.ctaLink && this.props.ctaLink.length > 0 && this.renderCustomCTAMobile()}
                {/*{this.props.nextVideo &&*/}
                {/*    <IconButton id={'arrowRight'} className={importedStyles.mobileNavigationButtonRight}*/}
                {/*                onClick={this.props.handleNextVideo}>*/}
                {/*        <NavigationArrow className={importedStyles.mobileNavigationIconRight}/>*/}
                {/*    </IconButton>*/}
                {/*}*/}
            </React.Fragment>
        )
    };
    handleCtaClick = () => {
        sendStat('cta_click', null, this.props.wallUuid, this.props.video.uuid);

        let win = window.open(this.props.ctaLink, "_blank");
        win.focus();
    };

    renderCustomCTA = () => {
        const {classes} = this.props;

        return (
            <Fab
                variant={'extended'}
                className={classes.cta}
                classes={{root: classes.cta}}

                onClick={this.handleCtaClick}
            >
                {this.props.ctaMessage && this.props.ctaMessage.length > 0 ? this.props.ctaMessage : 'Ver más'}
            </Fab>
        )
    };
    renderCustomCTAMobile = () => {
        const {classes} = this.props;

        return (
            <div style={{display: "flex", justifyContent: 'center'}}>
                <Button
                    variant={'contained'}
                    classes={{root: classes.cta}}
                    className={classes.cta}
                    onClick={this.handleCtaClick}
                >
                    {this.props.ctaMessage && this.props.ctaMessage.length > 0 ? this.props.ctaMessage : 'Ver más'}
                </Button>
            </div>

        )
    };

    renderVimeoPlayerDesktop = () => {

        return (
            <div className={importedStyles.vimeoDesktopWrapper}>
                {/*<Fade in={this.state.videoLoading} timeout={300} unmountOnExit mountOnEnter>*/}
                {/*    <CircularProgress size={70} className={importedStyles.vimeoSpinner}/>*/}
                {/*</Fade>*/}
                <Fade in={true} timeout={600} mountOnEnter unmountOnExit>
                    <Vimeo
                        id={this.props.video.vimeoId}
                        video={this.props.video.vimeoId}
                        className={importedStyles.iframeVimeoDesktop}
                        showByline={false}
                        showTitle={false}
                        controls={true}
                        pip={true}
                        onLoaded={() => this.setState({videoLoading: false})}
                        paused
                        onPlay={this.setVideoPlayPixelEvent}
                        responsive
                    />
                </Fade>
            </div>
        )
    };
    renderVimeoPlayer = () => {

        return (
            <React.Fragment>
                <div className={importedStyles.vimeoWrapper}>
                    {/*<Fade in={this.state.videoLoading} timeout={300}>*/}
                    {/*    <CircularProgress size={70} className={importedStyles.vimeoSpinner}/>*/}
                    {/*</Fade>*/}
                    <Fade in={true} timeout={600} unmountOnExit>
                        <Vimeo
                            id={this.props.video.vimeoId}
                            video={this.props.video.vimeoId}
                            className={importedStyles.iframeStyle}
                            showByline={false}
                            showTitle={false}
                            responsive
                            controls
                            onLoaded={() => this.setState({videoLoading: false})}
                            paused
                            onPlay={this.setVideoPlayPixelEvent}
                        />
                    </Fade>
                </div>
            </React.Fragment>
        )
    };
    renderMainImage = () => {
        let image = this.props.video;
        return (
            <React.Fragment>
                <Fade in={true} timeout={600} unmountOnExit>
                    <div className={importedStyles.mainImageWrapper}>
                        <img
                            alt={image.title}
                            src={image.url}
                            className={importedStyles.mainImage}
                            onLoad={() => this.setState({videoLoading: false})}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/img/png/thumbnail.png"
                            }}
                        />
                    </div>

                </Fade>
            </React.Fragment>
        )
    };

    renderDescription = () => {
        return (
            <Fade in={this.props.video && this.props.video.description} mountOnEnter unmountOnExit>
                <Interweave
                    allowList={ALLOWED_TAG_LIST.concat('iframe')}
                    content={this.props.video.description}
                    attributes={{className: importedStyles.descriptionContainer}}
                    containerTagName={'div'}
                />
            </Fade>
        )
    }


    render() {
        const {classes} = this.props;

        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                maxWidth={"md"}
                scroll={"body"}
                fullWidth
                fullScreen={isMobile}
                BackdropProps={{style: {backgroundColor: 'transparent'}}}
                transitionDuration={{appear: 300, enter: 400, exit: 500}}
                // closeAfterTransition
                disableScrollLock
                classes={{
                    root: importedStyles.dialogRoot,
                    paper: classes.dialog,
                    scrollPaper: importedStyles.topScrollPaper,
                    paperScrollBody: importedStyles.topPaperScrollBody,
                }}
            >
                <Hidden smDown>
                    <IconButton
                        style={{position: 'absolute', top: '-2rem', right: '-2.5rem', padding: 2, border: '1px solid #000', background: '#000', boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)'}}
                        onClick={this.props.onClose}
                    >
                        <CloseIcon style={{color: '#fff', fontSize: 32}}/>
                    </IconButton>
                </Hidden>


                <Fade in={this.state.videoLoading} unmountOnExit mountOnEnter timeout={300}>
                    <LinearProgress size={120} classes={{
                        root: importedStyles.linearProgress,
                        bar: importedStyles.linearProgressBar
                    }}/>
                </Fade>


                {/*/////////////////////////////////////////////////////*/}

                <div className={importedStyles.DetailVideo}>

                    <React.Fragment>
                        <Hidden smDown>

                                <Grid
                                    container
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        minHeight: '80vh'
                                    }}
                                >
                                    <Grid item xs={5} style={{
                                        background: '#000',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        {this.props.video.media_type === 'video' && this.renderVimeoPlayerDesktop()}
                                        {this.props.video.media_type === 'image' && this.renderMainImage()}
                                        {this.props.video.media_type === 'audio' && this.renderAudioPlayer()}

                                    </Grid>
                                    <Grid item xs={7} style={{display: 'flex', flexDirection: 'column'}}>

                                        <div className={importedStyles.bodyContainer}>
                                            <div className={importedStyles.titleContainer}>
                                                    <span
                                                        className={importedStyles.videoTitle}>{this.props.video.title}</span>
                                                {this.props.video.user &&
                                                    <p className={importedStyles.videoUserName}>{this.props.video.user.name}</p>}
                                                {this.props.video.name &&
                                                    <p className={importedStyles.videoUserName}>{this.props.video.name}</p>}
                                            </div>
                                            <Fade in={this.props.video && this.props.video.description} mountOnEnter unmountOnExit>
                                                <Interweave
                                                    allowList={ALLOWED_TAG_LIST.concat('iframe')}
                                                    content={this.props.video.description}
                                                    attributes={{className: importedStyles.descriptionContainer}}
                                                    containerTagName={'div'}
                                                />
                                            </Fade>

                                        </div>
                                        <Divider style={{
                                            backgroundColor: '#BDBDBD',
                                            height: 1,
                                            marginBottom: '0.5rem',
                                            marginTop: 'auto',
                                            marginLeft: '1.25rem',
                                            marginRight: '1.25rem'
                                        }} variant={"middle"}/>
                                        <div className={importedStyles.actionsWrapper}>

                                            <div className={importedStyles.navigationBox}>
                                                <Fade in={this.props.prevVideo}>
                                                    <IconButton
                                                        style={{
                                                            background: '#b5b5b5',
                                                            padding: 0,
                                                            marginRight: 15
                                                        }}
                                                        onClick={this.props.handlePrevVideo}>
                                                        <ChevronLeftSharp
                                                            style={{color: '#fff', fontSize: 42}}/>
                                                    </IconButton>
                                                </Fade>
                                                <Fade in={this.props.nextVideo}>
                                                    <IconButton style={{background: '#b5b5b5', padding: 0}}
                                                                onClick={this.props.handleNextVideo}>
                                                        <ChevronRightSharp
                                                            style={{color: '#fff', fontSize: 42}}/>
                                                    </IconButton>
                                                </Fade>
                                            </div>

                                            {this.props.ctaLink && this.props.ctaLink.length > 0 && this.renderCustomCTA()}
                                        </div>


                                    </Grid>
                                </Grid>

                        </Hidden>

                        <Hidden smUp>
                            <Fade
                                in={isMobile}
                                unmountOnExit mountOnEnter>
                                <div>
                                    <div className={importedStyles.navigationTopBar}>

                                        <IconButton
                                            style={{padding: 2, border: '1px solid #000'}}
                                            onClick={this.props.onClose}
                                        >
                                            <CloseIcon style={{color: '#000', fontSize: 32}}/>
                                        </IconButton>
                                    </div>
                                    {this.props.video.media_type === 'video' && this.renderVimeoPlayer()}
                                    {this.props.video.media_type === 'image' && this.renderMainImage()}
                                    {this.props.video.media_type === 'audio' && this.renderAudioPlayer()}

                                    <div className={importedStyles.bodyContainer}>
                                        <div className={importedStyles.titleContainer}>
                                                <span
                                                    className={importedStyles.videoTitle}>{this.props.video.title}</span>
                                            {this.props.video.user &&
                                                <p className={importedStyles.videoUserName}>{this.props.video.user.name}</p>}
                                            {this.props.video.name &&
                                                <p className={importedStyles.videoUserName}>{this.props.video.name}</p>}
                                        </div>

                                        <Fade in={this.props.video && this.props.video.description} mountOnEnter unmountOnExit>
                                            <Interweave
                                                allowList={ALLOWED_TAG_LIST.concat('iframe')}
                                                content={this.props.video.description}
                                                attributes={{className: importedStyles.descriptionContainer}}
                                                containerTagName={'div'}
                                            />
                                        </Fade>


                                        <div className={importedStyles.actionsWrapper}>
                                            <div>
                                                <Fade in={this.props.prevVideo}>
                                                    <IconButton
                                                        style={{background: '#b5b5b5', padding: 0, marginRight: 15}}
                                                        onClick={this.props.handlePrevVideo}>
                                                        <ChevronLeftSharp style={{color: '#fff', fontSize: 42}}/>
                                                    </IconButton>
                                                </Fade>
                                                <Fade in={this.props.nextVideo}>
                                                    <IconButton style={{background: '#b5b5b5', padding: 0}}
                                                                onClick={this.props.handleNextVideo}>
                                                        <ChevronRightSharp style={{color: '#fff', fontSize: 42}}/>
                                                    </IconButton>
                                                </Fade>
                                            </div>
                                            {this.props.ctaLink && this.props.ctaLink.length > 0 && this.renderCustomCTAMobile()}

                                        </div>


                                    </div>
                                </div>

                            </Fade>

                        </Hidden>

                    </React.Fragment>
                </div>

                {/*/////////////////////////////////////////////////*/}

{/*
                <Fade in={false} timeout={0}>

                    <DialogContent className={importedStyles.dialogContent}>

                        <Hidden smDown id={'hidden-on-mobile'}>
                            <Grid container style={{display: 'flex', justifyContent: 'center'}}>

                                {this.renderLeftNavigation()}

                                <Grid item xs={8}>
                                    {this.props.video.media_type === 'video' && this.renderVimeoPlayer()}
                                    {this.props.video.media_type === 'image' && this.renderMainImage()}
                                </Grid>
                                {this.renderRightNavigation()}
                            </Grid>
                        </Hidden>

                        <Hidden smUp id={'hidden-on-Desktop'}>
                            {this.props.video.media_type === 'video' && this.renderVimeoPlayer()}
                            {this.props.video.media_type === 'image' && this.renderMainImage()}
                        </Hidden>


                        <Fade in={this.state.videoError} mountOnEnter unmountOnExit timeout={700}>
                            {this.renderErrorMessage()}
                        </Fade>


                        <Grid container className={importedStyles.bodyContainer}>
                            <Hidden smUp>

                                <Grid item xs={2} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <IconButton disabled={!this.props.prevVideo} onClick={this.props.handlePrevVideo}>
                                        <img src={ArrowBackIcon} alt={'video-anterior'}
                                             style={{
                                                 height: '2.5rem',
                                                 width: '2.5rem',
                                                 filter: !this.props.prevVideo ? 'opacity(0.5)' : 'unset'
                                             }}/>
                                    </IconButton>
                                </Grid>
                            </Hidden>
                            <Grid item xs={8} sm={12} className={importedStyles.titleContainer}>
                                <span className={importedStyles.videoTitle}>{this.props.video.title}</span>
                                {this.props.video.user &&
                                    <p className={importedStyles.videoUserName}>{this.props.video.user.name}</p>}
                                {this.props.video.name &&
                                    <p className={importedStyles.videoUserName}>{this.props.video.name}</p>}
                            </Grid>
                            <Hidden smUp>

                                <Grid item xs={2} style={{display: 'flex', justifyContent: 'flex-start'}}>
                                    <IconButton disabled={!this.props.nextVideo} onClick={this.props.handleNextVideo}>
                                        <img src={ArrowForwardIcon} alt={'video-anterior'}
                                             style={{
                                                 height: '2.5rem',
                                                 width: '2.5rem',
                                                 filter: !this.props.nextVideo ? 'opacity(0.5)' : 'unset'
                                             }}/>
                                    </IconButton>
                                </Grid>
                            </Hidden>


                        </Grid>
                        {!isMobile && this.props.ctaLink && this.props.ctaLink.length > 0 && this.renderCustomCTA()}
                        {isMobile && this.props.ctaLink && this.props.ctaLink.length > 0 && this.renderCustomCTAMobile()}

                    </DialogContent>


                </Fade>*/}


                {/* MODALS, SNACKS AND ALERTS */}
                <Snack/>
                {/*********************/}
            </Dialog>
        );
    }
}

DetailVideoModalIframe.propTypes = {
    onClose: PropTypes.func.isRequired,
    video: PropTypes.object.isRequired,
    ctaMessage: PropTypes.string,
    ctaLink: PropTypes.string,
    handleNextVideo: PropTypes.func,
    handlePrevVideo: PropTypes.func,
    ctaBorderRadius: PropTypes.string,
    borderRadius: PropTypes.string,
};
const mapStateToProps = ({authReducer, detailVideoModalReducer, ConcursoReducer}) => {
    return ({
        user: authReducer.user,
        logged: authReducer.logged,
        videos: detailVideoModalReducer.videos,
        request: ConcursoReducer.request,
    });
};
export default connect(mapStateToProps)(withStyles(useStyles)(DetailVideoModalIframe));
